import type {
  ListingsAPIRequestBody,
  ListingsAPIResponseBody,
} from '@noths/polaris-client-listings-api';
import { fetchListingsData } from '@noths/polaris-client-listings-api';
import { isBrowser } from '@noths/polaris-client-utils';

import { isProd } from 'src/environment';
import { logger } from 'src/utils/serverLogger';

interface GetListingsDataArgs {
  body: ListingsAPIRequestBody;
  servingConfig?: string;
  userId?: string;
  visitorId?: string;
}

export const getListingsData = async ({
  body,
  servingConfig,
  userId,
  visitorId,
}: GetListingsDataArgs): Promise<ListingsAPIResponseBody | null> => {
  try {
    const clientSide = isBrowser();
    const data = await fetchListingsData({
      body,
      clientSide,
      env: isProd() ? 'prod' : 'qa',
      servingConfig,
      timeout: clientSide ? 15000 : 5500,
      userId,
      visitorId,
    });

    if ('products' in data) {
      return data as ListingsAPIResponseBody;
    }

    logger.error('bad response from listings-api', {
      error: data.message,
    });
  } catch (error) {
    logger.error('error fetching data from listings-api', {
      error: (error as Error).message,
    });
  }

  return null;
};
